// SigilRemovalTrackerCompact.tsx
import React from "react";
import { Box, Tooltip } from "@mui/material";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import { styled } from "@mui/material/styles";
import { useGlobalConfig } from "providers/GlobalConfig";
import { displayDateFromDateTime } from "UIComponents/SigilBaseDataGrid/columnHelper";
import { GlobalConfigType } from "types/configs";

const Track = styled(LinearProgress)(({ theme }) => ({
  height: 8,
  borderRadius: 999,
  backgroundColor: "rgba(255,255,255,0.28)",
  boxShadow: "inset 0 0 0 1px rgba(255,255,255,0.35)",
  [`& .${linearProgressClasses.bar}`]: {
    backgroundColor: "#fff",
    borderRadius: 999,
  },
}));

export default function SigilRemovalTrackerCompact() {
  const { globalConfig } = useGlobalConfig() as GlobalConfigType;
  const plan = globalConfig?.tenant?.props.planRemovals ?? 0;
  const used = globalConfig?.tenant?.props.casesLaunched ?? 0;
  const pct = plan ? Math.min(100, Math.round((used / plan) * 100)) : 0;

  const reset = globalConfig?.tenant?.props.resetDateUtc?.toDate();

  return (
    <Tooltip
      title={
        <Box sx={{ maxWidth: 280 }}>
          Enforcement credits used out of your total available. Includes any
          free credits you’ve earned. Resets on{" "}
          <b>{reset ? displayDateFromDateTime(reset) : "—"}</b>.
        </Box>
      }
      enterDelay={300}
    >
      <Box
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: 1,
          px: 1,
          py: 0.5,
          backgroundColor: "rgba(255,255,255,0.18)",
          borderRadius: 999,
          border: "1px solid rgba(255,255,255,0.38)",
          backdropFilter: "blur(2px)",
        }}
      >
        <Track variant="determinate" value={pct} sx={{ width: 96 }} />
        <Box
          component="span"
          sx={{
            fontSize: "0.75rem",
            fontWeight: 700,
            color: "#fff",
            textShadow: "0 1px 0 rgba(0,0,0,0.2)",
            letterSpacing: "0.02em",
            minWidth: 52,
            textAlign: "right",
          }}
        >
          {used} / {plan}
        </Box>
      </Box>
    </Tooltip>
  );
}
